import * as CryptoJS from "crypto-js";

export function isNullOrEmpty(text) {
  let isNullOrEmpty = false;

  if (text === "null" || text === "") {
    isNullOrEmpty = true;
  }

  if (typeof text !== "undefined" && text) {
    isNullOrEmpty = false;
  } else {
    isNullOrEmpty = true;
  }

  return isNullOrEmpty;
}

export function isNullOrEmptyList(list, item) {
  let isEmpty = true;

  if (list) {
    list.forEach(function (arrayItem) {
      if (isEmpty) {
        if (!isNullOrEmpty(arrayItem[item])) {
          isEmpty = false;
        }
      }
    });
  }

  return isEmpty;
}

export function parseBool(str) {
  // console.log(typeof str);
  // strict: JSON.parse(str)

  if (str == null) return false;

  if (typeof str === "boolean") {
    if (str === true) return true;

    return false;
  }

  if (typeof str === "string") {
    if (str == "") return false;

    str = str.replace(/^\s+|\s+$/g, "");
    if (str.toLowerCase() == "true" || str.toLowerCase() == "yes") return true;

    str = str.replace(/,/g, ".");
    str = str.replace(/^\s*\-\s*/g, "-");
  }

  // var isNum = string.match(/^[0-9]+$/) != null;
  // var isNum = /^\d+$/.test(str);
  if (!isNaN(str)) return parseFloat(str) != 0;

  return false;
}

export function getPhoneLink(phone) {
  if (!phone) {
    return "";
  }

  return `tel:${phone.replace(/\s/g, "")}`;
}

export function getEmailLink(email) {
  if (!email) {
    return "";
  }

  return `mailto:${email.replace(/\s/g, "")}`;
}

export function stripHtml(html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export function textShortener(text, len) {
  if (text && text.length > len) {
    text = text.substring(0, len) + "... (zkrácený text)";
  }
  return text;
}

export function needGoToDetail(text, len) {
  let needGoToDetail = false;
  if (text && text.length > len) {
    needGoToDetail = true;
  }
  return needGoToDetail;
}

export function encrypt(text) {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const cipherText = CryptoJS.AES.encrypt(text, secretKey).toString();
  return cipherText;
}

export function decrypt(text) {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const bytes = CryptoJS.AES.decrypt(text, secretKey);
  const plainText = bytes.toString(CryptoJS.enc.Utf8);
  return plainText;
}

export function getAuthConfig(uid) {
  //console.log(uid, process.env.REACT_APP_API_USERNAME, process.env.REACT_APP_API_PASSWORD);

  const base64 = "Basic " + btoa(uid + ":" + process.env.REACT_APP_API_USERNAME + ":" + process.env.REACT_APP_API_PASSWORD);
  //console.log(base64);

  return {
    headers: {
      Authorization: base64,
    },
  };
  //return { Authorization: "Basic " + btoa(uid + ":" + username + "" + pass) };
}

export function getRandomUID(len, numberOnly = false) {
  const chars = numberOnly ? "0123456789" : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let uid = "";
  for (let i = 0; i < len; i++) {
    uid += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return uid;
}
